var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "root"
  }, [!_vm.isView ? _c("ToolbarPanel", {
    ref: "toolbar"
  }) : _vm._e(), _c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [!_vm.isView ? _c("ItemPanel", {
    ref: "addItemPanel",
    attrs: {
      height: _vm.height
    }
  }) : _vm._e(), _c("div", {
    ref: "canvas",
    staticClass: "canvasPanel",
    style: {
      height: _vm.height + "px",
      width: _vm.isView ? "100%" : "70%",
      "border-bottom": _vm.isView ? 0 : null
    }
  }), !_vm.isView ? _c("DetailPanel", {
    ref: "detailPanel",
    attrs: {
      height: _vm.height,
      model: _vm.selectedModel,
      readOnly: _vm.$route.query.type == "view",
      users: _vm.users,
      authorities: _vm.authorities,
      groups: _vm.groups,
      categorys: _vm.categorys,
      signalDefs: _vm.processModel.signalDefs,
      messageDefs: _vm.processModel.messageDefs,
      onChange: function onChange(key, val) {
        _vm.onItemCfgChange(key, val);
      }
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };